import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SortControls = ({ sortBy, sortOrder, onSortChange, viewMode, onViewModeChange }) => {
  const sortOptions = [
    { value: 'name', label: 'Name' },
    { value: 'rating', label: 'Rating' },
    { value: 'riskLevel', label: 'Risk Level' },
    { value: 'creditsIssued', label: 'Credits Issued' },
    { value: 'avgPrice', label: 'Average Price' },
    { value: 'lastUpdated', label: 'Last Updated' },
    { value: 'registry', label: 'Registry' }
  ];

  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center space-x-4">
        {/* Sort Controls */}
        <div className="flex items-center space-x-2">
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={(value) => onSortChange(value, sortOrder)}
            className="w-40"
          />
          <Button
            variant="outline"
            size="sm"
            iconName={sortOrder === 'asc' ? 'ArrowUp' : 'ArrowDown'}
            onClick={() => onSortChange(sortBy, sortOrder === 'asc' ? 'desc' : 'asc')}
          />
        </div>

        {/* Results Count */}
        <div className="text-sm text-muted-foreground">
          Showing results sorted by {sortOptions?.find(opt => opt?.value === sortBy)?.label?.toLowerCase()}
        </div>
      </div>
      {/* View Mode Toggle */}
      <div className="flex items-center space-x-2">
        <span className="text-sm text-muted-foreground">View:</span>
        <div className="flex border border-border rounded-lg overflow-hidden">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`px-3 py-1 text-sm transition-smooth ${
              viewMode === 'grid' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-card-foreground hover:bg-muted'
            }`}
          >
            <Icon name="Grid3X3" size={14} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`px-3 py-1 text-sm transition-smooth ${
              viewMode === 'list' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-card-foreground hover:bg-muted'
            }`}
          >
            <Icon name="List" size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortControls;